<div class="modules-list">
    @if (settings.selectedModule.type !== 'zones_controller' && settingsHasModules()) {
        <form-section [subtitle]="subtitle(1346)">
            @if (settingsTiles.showTilesListLoader) {
                <div class="tiles-list-item__loading">
                    <loader></loader>
                </div>
            }
            @if (!settingsTiles.showTilesListLoader) {
                <div class="tiles-list-item tiles-list-item__row tiles-list-item__row--header">
                    <div class="tiles-list-item__header-buttons">{{ subtitle(1006) }}</div>
                    <div class="tiles-list-item__header-tile">{{ subtitle(1036) }}</div>
                    <div class="tiles-list-item__options">{{ subtitle(8671) }}</div>
                    @if (settingsTiles.hasContainers()) {
                        <div class="tiles-list-item__options">
                            {{ subtitle(8662) }}
                        </div>
                    }
                </div>
            }
            @if (!settingsTiles.showTilesListLoader) {
                @for (item of settingsTiles.tilesList; track item.values?.id; let containerIndex = $index) {
                    <div class="tiles-list-item">
                        @if (item.values !== null) {
                            <div class="tiles-list-item__row"
                                 data-testid="container">
                                <div class="tiles-list-item__buttons">
                                    @if (item.values.id !== 0) {
                                        <button class="tiles-list-item__button tiles-list-item__button--dark"
                                                type="button"
                                                [class]="{'cursor-pointer': containerIndex !== 0}"
                                                (click)="containerIndex !== 0 && settingsTiles.changeContainerOrder(item, 'up')">
                                            @if (containerIndex !== 0) {
                                                <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                                     width="16" height="16"
                                                     class="tiles-list-item__button-icon tiles-list-item__button-icon--rotate"
                                                     alt="">
                                            }
                                        </button>
                                        <button class="tiles-list-item__button tiles-list-item__button--dark"
                                                type="button"
                                                [class]="{'cursor-pointer': settingsTiles.checkLastContainer(containerIndex),
                                                        'cursor-default': !settingsTiles.checkLastContainer(containerIndex) }"
                                                (click)="settingsTiles.checkLastContainer(containerIndex)
                                                        && settingsTiles.changeContainerOrder(item, 'down')">
                                            @if (settingsTiles.checkLastContainer(containerIndex)) {
                                                <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                                     class="tiles-list-item__button-icon"
                                                     width="16" height="16"
                                                     alt="">
                                            }
                                        </button>
                                    }
                                </div>
                                <div class="tiles-list-item__tile tiles-list-item__tile--container">
                                    <img class="tiles-list-item__tile-img bg-tile-img"
                                         ngSrc="{{icon.setIcon(item.values.params.iconId)}}"
                                         width="36" height="36"
                                         alt=""/>
                                    <div class="color-light font-14">
                                        {{ subtitle(item.values.params.txtId) }}
                                    </div>
                                    <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                         class="tiles-list-item__tile-arrow-icon"
                                         [class]="{ 'tiles-list-item__tile-arrow-icon--rotate': !item.values.expanded}"
                                         width="20" height="20" alt=""/>
                                </div>
                                <div class="tiles-list-item__options"></div>
                                @if (settingsTiles.hasContainers()) {
                                    <div class="tiles-list-item__options">
                                        <div class="tiles-list-item__checkbox cursor-pointer"
                                             data-testid="container-checkbox"
                                             (click)="item.values.expanded = !item.values.expanded">
                                            @if (item.values.expanded) {
                                                <img ngSrc="/assets/img/icons/checkbox_checked.svg"
                                                     width="16" height="16"
                                                     alt=""/>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        @for (itemTile of item.elements; track itemTile; let idx = $index) {
                            <div class="tiles-list-item__row"
                                 data-testid="tile">
                                <div class="tiles-list-item__buttons">
                                    @if (item.elements.length > 1) {
                                        <button class="tiles-list-item__button"
                                                type="button"
                                                [class]="{'cursor-pointer': idx !== 0 }"
                                                (click)="settingsTiles.changeTileOrder(itemTile, 'up')">
                                            @if (idx !== 0) {
                                                <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                                     class="tiles-list-item__button-icon tiles-list-item__button-icon--rotate"
                                                     width="16" height="16"
                                                     alt=""/>
                                            }
                                        </button>
                                        <button class="tiles-list-item__button"
                                                type="button"
                                                [class]="{ 'cursor-default': idx === item.elements.length - 1,
                                                            'cursor-pointer': !(idx === item.elements.length - 1)}"
                                                (click)="settingsTiles.changeTileOrder(itemTile, 'down')">
                                            @if (idx !== item.elements.length - 1) {
                                                <img ngSrc="/assets/img/icons/drop-down-arrow.svg"
                                                     class="tiles-list-item__button-icon"
                                                     width="16" height="16"
                                                     alt=""/>
                                            }
                                        </button>
                                    }
                                </div>
                                <div class="tiles-list-item__tile"
                                     [class]="settingsTiles.setActivityClass(itemTile)
                                                +' ' + (settingsTiles.hasContainers() ? 'tiles-list-item__tile--branch' : '')">
                                    <div class="tiles-list-item__tile-img tiles-list-item__tile-img-svg"
                                         [class]="{ 'bg-tile-img': settingsTiles.setIconBackground(itemTile) }">
                                        <svg-icon
                                                src="{{settingsTiles.setIcon(itemTile)}}"></svg-icon>
                                    </div>
                                    <div class="tiles-list-item__tile-subtitles">
                                        <div class="font-14 text-align-left">
                                            {{ settingsTiles.setTileName(itemTile) }}
                                        </div>
                                        <div class="font-14 text-align-left">
                                            {{ settingsTiles.setSecondTileName(itemTile) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="tiles-list-item__options">
                                    <div class="tiles-list-item__checkbox cursor-pointer"
                                         data-testid="tile-checkbox"
                                         (click)="itemTile.visibility = !itemTile.visibility">
                                        @if (itemTile.visibility) {
                                            <img ngSrc="/assets/img/icons/checkbox_checked.svg"
                                                 width="16" height="16" alt=""/>
                                        }
                                    </div>
                                </div>
                                @if (settingsTiles.hasContainers()) {
                                    <div class="tiles-list-item__options"></div>
                                }
                            </div>
                        }
                    </div>
                }
            }

            @if (settingsTiles.showSendingDataLoader) {
                <div class="tiles-list-item__loading">
                    <loader></loader>
                </div>
            }

            @if (!settingsTiles.showSendingDataLoader) {
                <div class="action-buttons">
                    <form-button [subtitle]="subtitle(1256)"
                                 (click)="settingsTiles.setDefaultOrder()">
                    </form-button>
                    <form-button [subtitle]="subtitle(1255)"
                                 (click)="settingsTiles.saveTilesOrder()">
                    </form-button>
                </div>
            }
        </form-section>
    }
</div>
